const containerColl = document.querySelector('.js-collection')

if(containerColl){
  const triggers = containerColl.querySelector('.js-triggers')
  const banners = containerColl.querySelectorAll('.js-collection-banner')
  const filterTrigger = containerColl.querySelectorAll('.js-offcanvas-trigger[data-drawer-name="filters"]')
  const sortTrigger = containerColl.querySelectorAll('.js-offcanvas-trigger[data-drawer-name="sort"]')
  const closes = containerColl.querySelectorAll('.js-offcanvas-close')
  const dimmer = containerColl.querySelector('.js-offcanvas-dimmer')
  const href = window.location.href
  const filterPannel = containerColl.querySelector('.js-offcanvas[data-drawer-names="filters"]')
  const sortPannel = containerColl.querySelector('.js-offcanvas[data-drawer-names="sort"]')

  // FILTERS
  filterTrigger.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      filterPannel?.classList.add('is-expanded')
      sortPannel?.classList.remove('is-expanded')
      dimmer?.classList.add('show')
    })
  })

  // SORT
  sortTrigger.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      sortPannel?.classList.add('is-expanded')
      filterPannel?.classList.remove('is-expanded')
      dimmer?.classList.add('show')
    })
  })

  // DIMMER 
  dimmer?.addEventListener('click', () => {
    filterPannel?.classList.remove('is-expanded')
    sortPannel?.classList.remove('is-expanded')
    dimmer?.classList.remove('show')
  })

  // CLOSE
  closes.forEach((close) => {
    close.addEventListener('click', () => {
      filterPannel?.classList.remove('is-expanded')
      sortPannel?.classList.remove('is-expanded')
      dimmer?.classList.remove('show')
    })
  })

  banners.forEach(banner => {
    const videoMobile = banner.querySelector('.js-mobile-video video')
    const videoDesktop = banner.querySelector('.js-desktop-video video')

    const video = window.matchMedia('(max-width: 1024px)').matches ? videoMobile : videoDesktop

    const controlBtn = banner.querySelector('.js-video-control')
    const soundBtn = banner.querySelector('.js-video-sound-control')

    controlBtn.addEventListener('click', () => {
      if (video.paused) {
        video.play()
      } else {
        video.pause()
      }

      controlBtn.classList.toggle('is-paused')
    })

    soundBtn.addEventListener('click', () => {
      const shouldBeMuted = video.muted === false
      video.muted = shouldBeMuted
      soundBtn.classList.toggle('is-muted')
    })
  })
}